import request from "../utils/request"

export function login (data) {
	return request({
		url: '/auth/login',
		method: 'POST',
		data
	})
}

export function register (data) {
	return request({
		url: '/auth/register',
		method: 'POST',
		data
	})
}

export function logout (data) {
	return request({
		url: '/auth/logout',
		method: 'POST',
		data
	})
}

export function getVcode (data) {
	return request({
		url: '/auth/vcode',
		method: 'POST',
		data
	})
}

// 忘记了密码
export function resetPassword (data) {
	return request({
		url: '/auth/reset',
		method: 'POST',
		data
	})
}
// 重置密码
export function setPassword (data) {
	return request({
		url: '/auth/password',
		method: 'POST',
		data
	})
}
export function getUserInfo (data) {
	return request({
		url: '/user/userInfo',
		method: 'get',
		data
	})
}

export function setProfile (data) {
	return request({
		url: '/user/profile',
		method: 'POST',
		data
	})
}
